import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  apiCount: 0,
  loadingMessage: "",
  inlineLoader: false,
}

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    apiInitiated: (state) => {
      state.apiCount += 1
    },
    apiCompleted: (state) => {
      state.apiCount -= 1
    },
    updateLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload.message
    },
    setInlineLoader: (state, action) => {
      state.inlineLoader = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { apiInitiated, apiCompleted, updateLoadingMessage, setInlineLoader } = commonSlice.actions

export default commonSlice.reducer